export enum MediaBillingFeature {
    BASIC_MENA = 'video-mena',
    CRUNCHYROLL = 'video-crunchyroll',
    STARZ = 'video-starz',
    AMEDIATEKA = 'kp-amediateka-cact',
    PREMIUM = 'highquality',
}
